import { render } from "./ProfileUdItem.vue?vue&type=template&id=2efba2b1"
import script from "./ProfileUdItem.vue?vue&type=script&lang=js"
export * from "./ProfileUdItem.vue?vue&type=script&lang=js"
script.render = render

export default script